import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useAuth } from './AuthContext';
import api from '@/lib/api';

const EMPTY={notifications_unread:0,referrals_open:0,whatsapp_unread:0,undo:{available:false}};
const Context=createContext({...EMPTY,refresh:()=>Promise.resolve()});
const ROLES=new Set(['admin','mitarbeiter','teamleiter','vertriebspartner','promoter_internal']);

export function ShellStatusProvider({children}){
 const {user}=useAuth();const [status,setStatus]=useState(EMPTY);const controller=useRef(null);
 const refresh=useCallback(async()=>{
  if(!user?.id||!ROLES.has(user.role))return;
  controller.current?.abort();const next=new AbortController();controller.current=next;
  try{const {data}=await api.get('/me/shell-status',{signal:next.signal,timeout:10000});
   if(!next.signal.aborted)setStatus({...EMPTY,...data,undo:{...EMPTY.undo,...data?.undo}});
  }catch(e){if(e?.code!=='ERR_CANCELED'&&!next.signal.aborted){/* keep last safe snapshot */}}
 },[user?.id,user?.role]);
 useEffect(()=>{
  setStatus(EMPTY);if(!user?.id||!ROLES.has(user.role))return undefined;
  refresh();const visible=()=>{if(!document.hidden)refresh();};
  const timer=setInterval(visible,60000);
  window.addEventListener('focus',visible);window.addEventListener('shell:changed',visible);window.addEventListener('whatsapp:changed',visible);window.addEventListener('gamification:changed',visible);
  return()=>{clearInterval(timer);controller.current?.abort();window.removeEventListener('focus',visible);window.removeEventListener('shell:changed',visible);window.removeEventListener('whatsapp:changed',visible);window.removeEventListener('gamification:changed',visible);};
 },[user?.id,user?.role,refresh]);
 return <Context.Provider value={{...status,refresh}}>{children}</Context.Provider>;
}
export const useShellStatus=()=>useContext(Context);
